<template>
  <div class="bg-more">
    <section class="jumbotron jumbotron-fluid bg-cover-top bg-img-height-m font-KaushanScript" :style="{ backgroundImage: 'url(' + warehouse + ')' }">
      <div class="container">
        <div class="row">
          <div class="col-md-5 d-none d-md-block">
            <div class="d-flex flex-column align-items-start">
              <h1 class="text-primary font-weight-bold pt-5 font-size-xl">Warehouse</h1>
            </div>
          </div>
          <div class="col-md-5 d-md-none">
            <div class="text-center text-shadow mt-4 pt-2">
              <h1 class="text-primary font-weight-bold font-size-xl">Warehouse</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="container pb-5">
      <div class="form-row justify-content-center">
        <div class="col-md-12">
          <div class="d-flex flex-column justify-content-center">
            <p
              class="font-weight-bold text-secondary text-center pt-3 px-3 d-none d-md-block
            font-size-l"
            >
              {{ $t("warehouse.titleFormat") }}
            </p>
            <p
              class="font-weight-bold text-secondary text-center pt-3
            px-3 d-md-none font-size-m-plus"
            >
              {{ $t("warehouse.titleFormat") }}
            </p>

            <div class="form-row mt-2">
              <div class="col-md">
                <p class="text-more px-md-2">
                  {{ $t("warehouse.contentFormat") }}
                  <br />
                  {{ $t("warehouse.contentFormat2") }}
                  <br />
                  {{ $t("warehouse.contentFormat3") }}
                  <br />
                  {{ $t("warehouse.contentFormat4") }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="bg-cover-top d-none d-md-block bg-img-height-m mt-1" :style="{ backgroundImage: 'url(' + warehouse1 + ')' }"></div>
          <div class="bg-cover-top d-none d-md-block bg-img-height-m mt-1" :style="{ backgroundImage: 'url(' + warehouse2 + ')' }"></div>
          <div class="bg-cover-top d-none d-md-block bg-img-height-m mt-1" :style="{ backgroundImage: 'url(' + warehouse3 + ')' }"></div>
          <div class="bg-cover-top d-md-none bg-img-height-s mt-1" :style="{ backgroundImage: 'url(' + warehouse1 + ')' }"></div>
          <div class="bg-cover-top d-md-none bg-img-height-s mt-1" :style="{ backgroundImage: 'url(' + warehouse2 + ')' }"></div>
          <div class="bg-cover-top d-md-none bg-img-height-s mt-1" :style="{ backgroundImage: 'url(' + warehouse3 + ')' }"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import warehouse from "@/assets/img/warehouse.png";
import warehouse1 from "@/assets/img/warehouse-1.jpg";
import warehouse2 from "@/assets/img/warehouse-2.jpg";
import warehouse3 from "@/assets/img/warehouse-3.jpg";
export default {
  data() {
    return {
      warehouse,
      warehouse1,
      warehouse2,
      warehouse3,
    };
  },
  methods: {
    contactSubmit() {
      $("#contactModal").modal("show");
      setTimeout(() => {
        $("#contactModal").modal("hide");
      }, 5000);
    },
  },
};
</script>
